export default __webpack_public_path__ + "static/media/main.83b3f93c.jpg";